/**
 * Re-opens the cookie-preferences modal from a UI control after the user has
 * already made an initial choice (e.g. the "Cookie preferences" footer link).
 *
 * Dynamically imports `vanilla-cookieconsent` so the call site stays SSR-safe
 * and so the consent library bundle is shared with the mount component on
 * subsequent imports (Vite dedupes the dynamic import).
 */
export async function openCookiePreferences(): Promise<void> {
  if (typeof window === 'undefined') return;
  const CookieConsent = await import('vanilla-cookieconsent');
  CookieConsent.showPreferences();
}
